export class Voucher {
    branchAddress: string;
    branchName: string;
    contractCode: string;
    createdOn: string;
    createdOnWritten: string;
    customerAddress: string;
    customerCode: string;
    customerEmail: string;
    customerFiscald: string;
    customerName: string;
    documentType: string;
    observations: string;
    salesOrgCode: string;
    salesOrgName: string;
    totalAmount: number;
    originalAmount: number;
    voucherCode: string;

    constructor() {
        this.branchAddress = "";
        this.branchName = "";
        this.contractCode = "";
        this.createdOn = "";
        this.customerAddress = "";
        this.customerCode = "";
        this.customerEmail = "";
        this.customerFiscald = "";
        this.customerName = "";
        this.documentType = "";
        this.observations = "";
        this.salesOrgCode = "";
        this.salesOrgName = "";
        this.totalAmount = 0;
        this.originalAmount = 0;
        this.voucherCode = "";
        this.createdOnWritten = "";
    }
}
